import React from 'react';
import { motion } from 'framer-motion';
import { usePublicLanguage } from '../../contexts/PublicLanguageContext';

const AboutPage = () => {
  const { t } = usePublicLanguage();
  
  return (
    <div className="max-w-4xl mx-auto px-4 py-16">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        className="text-center mb-12"
      >
        <h1 className="text-4xl font-bold text-gray-900 mb-4">
          {t('about.title')}
        </h1>
      </motion.div>
    </div>
  );
};

export default AboutPage;
